<template lang="html">
  <div
    class="select__form__wrp"
    :style="`
      width: ${computedWidth};
    `"
    :class="{disabled}"
    @click="onSelectWrpClick"
  >
    <div class="select__cnt" @click="onFocus">
      <input
        class="input__form"
        :class="{
          error__form: observableError,
          infocus: inFocus || optionsPressed,
          disabled
        }"
        :placeholder="currentLabel && !inFocus ? '' : placeholder"
        v-model="filterText"
        autocomplete="off"
        @focus="onFocus"
        @input="$emit('filter', $event.target.value)"
        @blur="onBlurInput"
        ref="search"
        type="text"
        :disabled="inFocus && !searchable"
      >
      <div class="select__label" v-show="currentLabel && !inFocus">{{currentLabel}}</div>
      <div v-show="!isLoading" class="arrow__icon__wrp" :class="{disabled}" @click.stop="onIconClicked">
        <div
          class="arrow__icon"
          :class="{ up__icon: inFocus }"
          v-html="require('@/assets/img/input-droplist.svg')"
        ></div>
      </div>
      <div v-show="isLoading" class="load__icon">
        <div></div><div></div><div></div>
      </div>
    </div>

    <div
      v-if="showReset && value"
      class="reset__icon__wrp"
      @click="optionClicked('')"
    >
      <div
        class="reset__icon"
        v-html="require('@/assets/img/icon-close.svg')"
      ></div>
    </div>

    <ul
      v-if="filteredOptions.length"
      v-show="inFocus"
      class="options__items"
      :style="{ maxHeight }"
      :class="listPosition"
      :key="getListKey()"
      @mousedown="optionsPressed = true">
      <li
        class="option__item"
        :class="{ selected: option[valueName] === observableValue }"
        v-for="(option,index) in filteredOptions"
        :key="`${option[valueName]}${index}`"
        @click.stop="optionClicked(option[valueName])"
      >
        {{option[labelName]}}
      </li>
      <li v-show="!filteredOptions.length && filterText" class="empty__item">
        Ничего не найдено
      </li>
    </ul>

    <slot />

    <div class="desc__block" v-if="!observableError && desc">{{desc}}</div>
    <bimErrorField :error="observableError" />
  </div>
</template>

<script>
import ValidationFormMixin from '@/utils/validate2/validation-form-mixin'
import bimErrorField from '@/components/form/bimErrorField/bimErrorField'

export default {
  name: 'bimSelect',
  mixins: [ValidationFormMixin],
  components: {
    bimErrorField
  },
  props: {
    /**
     * Возможность очистить селект
     */
    showReset: Boolean,
    /**
     * Поясняющая подсказка снизу
     */
    desc: String,
    /**
     * Делает селект не активный
     */
    disabled: Boolean,
    /**
     * Возможность поиска
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Значение селекта (берется из v-model)
     */
    value: {
      type: [String, Number]
    },
    /**
     * Текст селекта
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Массив options
     */
    options: {
      type: Array,
      default: () => ([]),
    },
    /*
    * Показываем иконку что идет загрузка списка
    */
    isLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Какое поле прописывать в option в качестве текста
     */
    labelName: {
      type: String,
      default: 'label'
    },
    /**
     * Какое поле возвращать в v-model из текущего объекта
     */
    valueName: {
      type: String,
      default: 'value'
    },
    /**
     * Ширина
     */
    width: {
      type: [String, Number],
      default: '300'
    },
    /**
     * Максимальная высота списка
     */
    maxHeight: {
      type: String,
      default: '175px'
    },
    /**
     * Позиционирование списка<br/>
     * top/bottom
     */
    listPosition: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      filterText: '', // поиск в списке
      currentLabel: '', // label выбранного элемента
      observableValue: this.value, // value выбранного элемента
      inFocus: false,
      optionsPressed: false, // зажали мышкой на блоке options
      blurTime: null
    }
  },
  mounted () {
    if (this.observableValue && this.options.length) {
      this.selectOption(this.observableValue)
    }

    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocumentClick)
  },
  computed: {
    filteredOptions () {

      if (!this.filterText) {
        return this.options
      }

      const filter = String(this.filterText).toLowerCase()

      return this.options.filter(option => {
        const label = String(option[this.labelName]).toLowerCase()

        return ~label.indexOf(filter)
      })
    },
    computedWidth () {
      if (+this.width) {
        return this.width + 'px'
      } else {
        return this.width
      }
    },
    selectId () {
      const randomNumber = (min, max) => {
        const rand = min - 0.5 + Math.random() * (max - min + 1)
        return Math.round(rand)
      }

      return randomNumber(1234, 9786432)
    },
  },
  methods: {

    onIconClicked (e) {
      e.stopPropagation()
      this.optionsPressed = false

      if (this.inFocus) {
        this.onBlurInput()
      } else {
        this.onFocus()
      }
    },

    onFocus (e) {
      this.inFocus = true
      if (e && e.target.value) {
        this.$emit('filter', e.target.value)
      }
    },

    onDocumentClick (e) {
      if (!this.inFocus) {
        return
      }

      if (e.selectId !== this.selectId) {
        this.onBlurInput()
      }
    },

    onSelectWrpClick (e) {
      e.selectId = this.selectId
    },

    onBlurInput () {
      if (this.optionsPressed) {
        return
      }

      this.inFocus = false

      if (this.filterText) {
        this.$emit('filter', '')
      }

      this.filterText = ''

      this.selectOption(this.observableValue)

      this.blurTime = new Date().getTime()
    },

    optionClicked (value) {
      this.filterText = ''
      this.selectOption(value)
      this.inFocus = false
      this.optionsPressed = false
    },

    selectOption (value, emitValue = true) {
      const currentLabel = this.getCurrentLabel(value)

      const oldValue = this.observableValue

      if (currentLabel) {

        this.observableValue = value

        this.currentLabel = currentLabel

      } else {
        this.observableValue = ''

        this.currentLabel = ''
      }

      if (emitValue) {
        /**
         * Событие срабатывает при любом выборе, даже того же значения
         * @property value
         */
        this.$emit('input', value)

        if (value !== oldValue) {
          /**
           * Событие срабатывает только когда изменяется значение у селекта
           * @property value
           */
          this.$emit('change', value)
        }
      }

      if (this.$refs.search) {
        this.$refs.search.value = ''
      }
    },

    getCurrentLabel (value, options = []) {
      options = options.length ? options : this.options.slice()

      const option = options.find(option => option[this.valueName] === value)

      return option ? option[this.labelName] : ''
    },

    getListKey () {
      return String(Math.random())
    },
  },
  watch: {
    inFocus (val) {
      if (!val) this.$emit('blur')
    },
    value (value) {

      const currentLabel = this.getCurrentLabel(value)

      if (!currentLabel && this.options.length) {
        this.selectOption(null, true)
      }

      if (currentLabel) {
        this.selectOption(value, false)
      }
    },
    options (options) {

      if (!this.getCurrentLabel(this.observableValue, options)) {
        return
      }

      this.selectOption(this.observableValue)
    }
  }
}
</script>

<style lang="scss" scoped>
  .desc__block {
    margin-left: 12px;
    margin-top: 6px;
    color: #6c6c6c;
    font-size: 13px;
  }

  .reset__icon__wrp {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(150%, -50%);

    ::v-deep svg {
      width: 10px;
    }
  }

  .select__form__wrp,
  .select__cnt {
    position: relative;
    cursor: pointer;
    &.disabled {
      cursor: default;
      pointer-events: none;
      background-color: $white-color-100;
      border-color: $white-color-100;
    }
  }

  .input__form {
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
    height: 36px;
    border: 1px solid $white-color-700;
    border-radius: 4px;
    padding: 0 12px;
    outline: none;
    transition: border-color 0.2s;
    font-size: 14px;
    letter-spacing: 0.1px;
    cursor: pointer;
  }

  .input__form:disabled {
    background: white;
  }

  .select__cnt:hover .input__form {
    border-color: $black-color-50;
  }

  .input__form.infocus {
    transition: none;
    background-color: $white-color-300;
    border-color: $white-color-300 !important;
  }

  // Отключаем кнопку
  .input__form.disabled,
  .select__cnt:hover .input__form.disabled {
    cursor: default;
    pointer-events: none;
    background-color: $white-color-100;
    border-color: $white-color-100;
    opacity: 0.9;
  }

  .input__form.error__form {
    border-color: $red-color-400;
  }

  .input__form.error__form::placeholder {
    color: $red-color-400;
    opacity: 1;
  }

  .arrow__icon__wrp {
    width: 35px;
    height: 36px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    user-select: none;
    &.disabled {
      cursor: default;
      pointer-events : none;
      opacity        : .4;
    }
  }

  .arrow__icon {
    position: absolute;
    top: 50%;
    right: 14px;
    display: block;
    width: 12px;
    height: 8px;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .arrow__icon.up__icon {
    transform: rotate(180deg) translateY(65%)
  }

  .options__items {
    position: absolute;
    top: 46px;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 10;
    border-radius: 5px;
    box-shadow: 0 10px 30px rgba(0,0,0, .05);
    margin: 0;
    list-style-type: none;
    overflow-y: auto;
    padding: 5px 0;
    color: $black-color-300;
  }

  .options__items.top {
    top: -14px;
    transform: translateY(-100%);
  }

  .option__item,
  .empty__item {
    padding: 10px 14px;
    font-size: 15px;
    cursor: pointer;
    letter-spacing: 0.2px;
  }

  .empty__item {
    cursor: default;
    color: #888;
  }

  .option__item:hover {
    background-color: $white-color-100
  }

  .option__item.selected {
    color: $primary-color;
  }

  .select__label {
    position: absolute;
    color: $black-color;
    left: 12px;
    top: 50%;
    right: 38px;
    transform: translateY(-50%);
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    pointer-events: none;
  }

  .arrow__icon /deep/ svg {
    display: block;
  }

  .load__icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    margin-top: -30px;
    width: 20px;
    height: 20px;
  }

  .load__icon div {
    display: inline-block;
    position: absolute;
    width: 2px;
    background: #999;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }

  .load__icon div:nth-child(1) {
    animation-delay: -0.24s;
  }

  .load__icon div:nth-child(2) {
    left: 4px;
    animation-delay: -0.12s;
  }

  .load__icon div:nth-child(3) {
    left: 8px;
    animation-delay: 0;
  }

  @keyframes lds-facebook {
    0% {
      top: 20px;
      height: 38px;
    }
    50%, 100% {
      top: 30px;
      height: 20px;
    }
  }

</style>
